<template>
  <CardContainer>
    <div style="margin-bottom: 16px;">
      <hl-button @click="add" v-if="addRole">
        新增
      </hl-button>
    </div>
    <CommonForm @search="formSearch" :form-json="formjson" />
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
    >
    </CommonTable>
    <DistributorEdit
      :row="row"
      @refresh="formSearch(cacheData, cachePage)"
      v-if="visible"
      :visible.sync="visible"
    />
  </CardContainer>
</template>

<script>
import formjson from './Model/Formjson.Distributor'
import tablejson from './Model/Tablejson.Distributor'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
import DistributorEdit from './DistributorEdit'
import { verifyPassword } from '@/utils/utils'
export default {
  mixins: [formTableMixin],
  props: {
    roleList: {
      type: Array
    }
  },
  components: {
    DistributorEdit
  },
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit',
          hide: () => {
            return !this.updateRole
          }
        },
        {
          name: '详情',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        },
        {
          name: '禁用',
          type: 'disabled',
          hide: (row) => {
            return row.status == 'DISABLED' || !this.stateRole
          }
        },
        {
          name: '启用',
          type: 'enable',
          hide: (row) => {
            return row.status == 'ENABLE' || !this.stateRole
          }
        },
        {
          name: '删除',
          type: 'delete',
          hide: () => {
            return !this.deleteRole
          }
        },
        {
          name: '登录后台',
          type: 'login',
          width: 74,
          hide: () => {
            return !this.loginRole
          }
        }
      ],
      visible: false,
      queryApi: this.$api.channel.distributor_list,
      row: {}
    }
  },
  computed: {
    /********* 权限 ***********/
    // 查询的权限
    listRole() {
      let val = getRoleByOperationCode(this.roleList, 'query')
      return val ? val.isPermission == 'Y' : false
    },
    // 新建的权限
    addRole() {
      let val = getRoleByOperationCode(this.roleList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑的权限
    updateRole() {
      let val = getRoleByOperationCode(this.roleList, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情的权限
    detailRole() {
      let val = getRoleByOperationCode(this.roleList, 'detail')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除的权限
    deleteRole() {
      let val = getRoleByOperationCode(this.roleList, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 禁用启用的权限
    stateRole() {
      let val = getRoleByOperationCode(this.roleList, 'state')
      return val ? val.isPermission == 'Y' : false
    },
    // 登录后台的权限
    loginRole() {
      let val = getRoleByOperationCode(this.roleList, 'login')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  methods: {
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data = {
        ...data
      }
      this.search(data, pageObj, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm('确认删除该经销商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .get(this.$api.channel.distributor_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              const pageObj = {
                ...this.cachePage
              }
              if (this.tableData.length <= 1) {
                if (this.cachePage.pageNum - 1 >= 1) {
                  pageObj.pageNum = this.cachePage.pageNum - 1
                }
              }
              this.formSearch(this.cacheData, pageObj)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    async handleSetState(row, status) {
      verifyPassword()
        .then((password) => {
          let tip = status == 'ENABLE' ? '启用' : '禁用'
          let params = {
            id: row.id,
            status,
            password
          }
          this.$ajax
            .post(this.$api.channel.distributor_state_change, params)
            .then(() => {
              this.$message.success(`${tip} 成功`)
              this.formSearch(this.cacheData, this.cachePage)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDetail(row) {
      const { href } = this.$router.resolve({
        name: 'ChannelDistributorDetail',
        query: {
          id: row.id
        }
      })
      window.open(href, '_blank')
    },
    async handleLogin(row) {
      const params = {
        id: row.id,
        accountType: 'distributor'
      }
      const { code } = await this.$ajax
        .get(this.$api.common.login_auth_code, params)
        .then((res) => {
          return res.data
        })
        .catch(() => {})

      if (code) {
        const { href } = this.$router.resolve({
          name: 'Login',
          query: {
            code
          }
        })
        window.open(href, '_blank')
      }
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'disabled':
          this.handleSetState(row, 'DISABLED')
          break
        case 'enable':
          this.handleSetState(row, 'ENABLE')
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'login':
          this.handleLogin(row)
          break
      }
    }
  }
}
</script>
